import { ReactComponent as NextPageDark } from "../../../styles/icon/right_arrow_dark.svg"
import { ReactComponent as NextPageGrey } from "../../../styles/icon/right_arrow.svg"
import { ReactComponent as PreviousPageDark } from "../../../styles/icon/left_arrow_dark.svg"
import { ReactComponent as PreviousPageGrey } from "../../../styles/icon/left_arrow.svg"
import { ReactComponent as FirstPageDark } from "../../../styles/icon/first_page_dark.svg"
import { ReactComponent as FirstPageGrey } from "../../../styles/icon/first_page.svg"
import styled from "styled-components";

export const NextPageDarkIcon = styled(NextPageDark)`
  height: 15px;
  width: 15px;
`;
export const NextPageGreyIcon = styled(NextPageGrey)`
  height: 15px;
  width: 15px;
`;
export const PreviousPageDarkIcon = styled(PreviousPageDark)`
  height: 15px;
  width: 15px;
`;
export const PreviousPageGreyIcon = styled(PreviousPageGrey)`
  height: 15px;
  width: 15px;
`;
export const FirstPageDarkIcon = styled(FirstPageDark)`
  height: 15px;
  width: 15px;
`;
export const FirstPageGreyIcon = styled(FirstPageGrey)`
  height: 15px;
  width: 15px;
`;